//Auth 
export const REGISTER_USER_SUCCESSFULLY = 'REGISTER_USER_SUCCESSFULLY';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';

export const USER_LOGIN_SUCCESSFULLY = 'USER_LOGIN_SUCCESSFULLY';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';

export const FORGOT_PASSWORD_SUCCESSFULLY = 'FORGOT_PASSWORD_SUCCESSFULLY';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';

export const RESET_PASSWORD_SUCCESSFULLY = 'RESET_PASSWORD_SUCCESSFULLY';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const VERIFY_USER_SUCCESSFULLY = 'VERIFY_USER_SUCCESSFULLY';
export const VERIFY_USER_FAILED = 'VERIFY_USER_FAILED';

// settings
export const GET_FRANCHISE_SUCCESSFULLY = 'GET_FRANCHISE_SUCCESSFULLY';
export const GET_FRANCHISE_FAILED = 'GET_FRANCHISE_FAILED';

export const GET_USER_DETAIL_SUCCESSFULLY = 'GET_USER_DETAIL_SUCCESSFULLY';
export const GET_USER_DETAIL_FAILED = 'GET_USER_DETAIL_FAILED';

export const GET_USER_GROUP_SUCCESSFULLY = 'GET_USER_GROUP_SUCCESSFULLY';
export const GET_USER_GROUP_FAILED = 'GET_USER_GROUP_FAILED';

export const GET_NOTIFICATION_SUCCESSFULLY = 'GET_NOTIFICATION_SUCCESSFULLY';
export const GET_NOTIFICATION_FAILED = 'GET_NOTIFICATION_FAILED';

export const GET_USER_ROLES = 'GET_USER_ROLES';
export const GET_USER_ROLES_FAILED = 'GET_USER_ROLES_FAILED';

///// User management
//user
export const ADD_USER_SUCCESSFULLY = 'ADD_USER_SUCCESSFULLY';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';

export const GET_USER_LIST_SUCCESSFULLY = 'GET_USER_LIST_SUCCESSFULLY';
export const GET_USER_LIST_FAILED = 'GET_USER_LIST_FAILED';

export const GET_GROUP_LIST_SUCCESSFULLY = 'GET_GROUP_LIST_SUCCESSFULLY';
export const GET_GROUP_LIST_FAILED = 'GET_GROUP_LIST_FAILED';

export const GET_FRANCHISE_LIST_SUCCESSFULLY = 'GET_FRANCHISE_LIST_SUCCESSFULLY';
export const GET_FRANCHISE_LIST_FAILED = 'GET_FRANCHISE_LIST_FAILED';

export const EDIT_USER_SUCCESSFULLY = 'EDIT_USER_SUCCESSFULLY';
export const EDIT_USER_FAILED = 'EDIT_USER_FAILED';

export const GET_USERS_DETAIL_SUCCESSFULLY = 'GET_USERS_DETAIL_SUCCESSFULLY';
export const GET_USERS_DETAIL_FAILED = 'GET_USERS_DETAIL_FAILED';


export const UPDATE_USER_SUCCESSFULLY = 'UPDATE_USER_SUCCESSFULLY';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const DELETE_USER_SUCCESSFULLY = 'DELETE_USER_SUCCESSFULLY';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';

export const GET_USER_ROLES_SUCCESSFULLY = 'GET_USER_ROLES_SUCCESSFULLY';
// export const GET_USER_ROLES_FAILED = 'GET_USER_ROLES_FAILED';

//group
export const ADD_GROUP_SUCCESSFULLY = 'ADD_GROUP_SUCCESSFULLY';
export const ADD_GROUP_FAILED = 'ADD_GROUP_FAILED';

export const GET_GROUP_DETAILS_SUCCESSFULLY = 'GET_GROUP_DETAILS_SUCCESSFULLY';
export const GET_GROUP_DETAILS_FAILED = 'GET_GROUP_DETAILS_FAILED';

export const DELETE_GROUP_SUCCESSFULLY = 'DELETE_GROUP_SUCCESSFULLY';
export const DELETE_GROUP_FAILED = 'DELETE_GROUP_FAILED';

export const UPDATE_GROUP_SUCCESSFULLY = 'UPDATE_GROUP_SUCCESSFULLY';
export const UPDATE_GROUP_FAILED = 'UPDATE_GROUP_FAILED';

// Residential Management
export const GET_CUSTOMER_SUCCESSFULLY = 'GET_CUSTOMER_SUCCESSFULLY';
export const GET_CUSTOMER_FAILED = 'GET_CUSTOMER_FAILED';

export const ADD_CUSTOMER_SUCCESSFULLY = 'ADD_CUSTOMER_SUCCESSFULLY';
export const ADD_CUSTOMER_FAILED = 'ADD_CUSTOMER_FAILED';

export const GET_CUSTOMER_LIST_SUCCESSFULLY = 'GET_CUSTOMER_LIST_SUCCESSFULLY';
export const GET_CUSTOMER_LIST_FAILED = 'GET_CUSTOMER_LIST_FAILED';

export const GET_TECHNICIAN_LIST = 'GET_TECHNICIAN_LIST';
export const GET_TECHNICIAN_LIST_FAILED = 'GET_TECHNICIAN_LIST_FAILED';

export const GET_SERVICE_HISTORY = 'GET_SERVICE_HISTORY';
export const GET_SERVICE_HISTORY_FAILED = 'GET_SERVICE_HISTORY_FAILED';

export const GET_LEAD_LIST_SUCCESSFULLY = 'GET_LEAD_LIST_SUCCESSFULLY';
export const GET_LEAD_LIST_FAILED = 'GET_LEAD_LIST_FAILED';

export const ADD_LEAD_SUCCESSFULLY = 'ADD_LEAD_SUCCESSFULLY';
export const ADD_LEAD_FAILED = 'ADD_LEAD_FAILED';

export const GET_LEAD_SUCCESSFULLY = 'GET_LEAD_SUCCESSFULLY';
export const GET_LEAD_FAILED = 'GET_LEAD_FAILED';

export const GET_SERVICE_ORDER_ENQUIRY = 'GET_SERVICE_ORDER_ENQUIRY';
export const GET_SERVICE_ORDER_ENQUIRY_FAILED = 'GET_SERVICE_ORDER_ENQUIRY_FAILED';

export const UPDATE_LEAD_SUCCESSFULLY = 'UPDATE_LEAD_SUCCESSFULLY';
export const UPDATE_LEAD_FAILED = 'UPDATE_LEAD_FAILED';

export const FIELD_OFFICE = 'FIELD_OFFICE';
export const FIELD_OFFICE_FAILED = 'FIELD_OFFICE_FAILED';

export const GET_ACCOUNT_INFO_SUCCESSFULLY = 'GET_ACCOUNT_INFO_SUCCESSFULLY';
export const GET_ACCOUNT_INFO_FAILED = 'GET_ACCOUNT_INFO_FAILED';

export const GET_SERVICE_ORDER_LIST = 'GET_SERVICE_ORDER_LIST';
export const GET_SERVICE_ORDER_LIST_FAILED = 'GET_SERVICE_ORDER_LIST_FAILED';

export const VIEW_SERVICE_ORDER = 'VIEW_SERVICE_ORDER';
export const VIEW_SERVICE_ORDER_FAILED = 'VIEW_SERVICE_ORDER_FAILED';

export const ADD_SERVICE_ORDER = 'ADD_SERVICE_ORDER';
export const ADD_SERVICE_ORDER_FAILED = 'ADD_SERVICE_ORDER_FAILED';

export const UPDATE_SERVICE_ORDER = 'UPDATE_SERVICE_ORDER';
export const UPDATE_SERVICE_ORDER_FAILED = 'UPDATE_SERVICE_ORDER_FAILED';

export const ADD_NEW_CARD = 'ADD_NEW_CARD';
export const ADD_NEW_CARD_FAILED = 'ADD_NEW_CARD_FAILED';

export const GET_CARD_LIST = 'GET_CARD_LIST';
export const GET_CARD_LIST_FAILED = 'GET_CARD_LIST_FAILED';

export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CARD_FAILED = 'UPDATE_CARD_FAILED';

export const DELETE_CARD = 'DELETE_CARD';
export const DELETE_CARD_FAILED = 'DELETE_CARD_FAILED';

export const BLOCK_LIST = 'BLOCK_LIST';
export const BLOCK_LIST_FAILED = 'BLOCK_LIST_FAILED';

export const ADD_ACCOUNT_NOTES = 'ADD_ACCOUNT_NOTES';
export const ADD_ACCOUNT_NOTES_FAILED = 'ADD_ACCOUNT_NOTES_FAILED';

export const GET_ACCOUNT_NOTES = 'GET_ACCOUNT_NOTES';
export const GET_ACCOUNT_NOTES_FAILED = 'GET_ACCOUNT_NOTES_FAILED';

export const GET_AUTHORIZED_USER = 'GET_AUTHORIZED_USER';
export const GET_AUTHORIZED_USER_FAILED = 'GET_AUTHORIZED_USER_FAILED';

export const ADD_AUTHORIZED_USER = 'ADD_AUTHORIZED_USER';
export const ADD_AUTHORIZED_USER_FAILED = 'ADD_AUTHORIZED_USER_FAILED';

export const DELETE_AUTHORIZED_USER = 'DELETE_AUTHORIZED_USER';
export const DELETE_AUTHORIZED_USER_FAILED = 'DELETE_AUTHORIZED_USER_FAILED';

export const UPDATE_NOTIFICATION_SUCCESSFULLY = 'UPDATE_NOTIFICATION_SUCCESSFULLY';
export const UPDATE_NOTIFICATION_FAILED = 'UPDATE_NOTIFICATION_FAILED';

export const GET_CALL_LOG = 'GET_CALL_LOG';
export const GET_CALL_LOG_FAILED = 'GET_CALL_LOG_FAILED';

export const ADD_CALL_LOG = 'ADD_CALL_LOG';
export const ADD_CALL_LOG_FAILED = 'ADD_CALL_LOG_FAILED';

export const GET_PRICING_HISTORY = 'GET_PRICING_HISTORY';
export const GET_PRICING_HISTORY_FAILED = 'GET_PRICING_HISTORY_FAILED';

export const VIEW_SERVICE = 'VIEW_SERVICE';
export const VIEW_SERVICE_FAILED = 'VIEW_SERVICE_FAILED';

export const GET_PAUSE_SERVICE = 'GET_PAUSE_SERVICE';
export const GET_PAUSE_SERVICE_FAILED = 'GET_PAUSE_SERVICE_FAILED';

export const PAUSE_SERVICE = 'PAUSE_SERVICE';
export const PAUSE_SERVICE_FAILED = 'PAUSE_SERVICE_FAILED';

export const UPDATE_PAUSE_SERVICE = 'UPDATE_PAUSE_SERVICE';
export const UPDATE_PAUSE_SERVICE_FAILED = 'UPDATE_PAUSE_SERVICE_FAILED';

export const DELETE_PAUSE_SERVICE = 'DELETE_PAUSE_SERVICE';
export const DELETE_PAUSE_SERVICE_FAILED = 'DELETE_PAUSE_SERVICE_FAILED';

export const EDIT_SERVICE = 'EDIT_SERVICE';
export const EDIT_SERVICE_FAILED = 'EDIT_SERVICE_FAILED';

export const GET_PAUSE_REASON = 'GET_PAUSE_REASON';
export const GET_PAUSE_REASON_FAILED = 'GET_PAUSE_REASON_FAILED';

export const GET_DOG_LIST = 'GET_DOG_LIST';
export const GET_DOG_LIST_FAILED = 'GET_DOG_LIST_FAILED';

export const ADD_DOG = 'ADD_DOG';
export const ADD_DOG_FAILED = 'ADD_DOG_FAILED';

export const UPDATE_DOG = 'UPDATE_DOG';
export const UPDATE_DOG_FAILED = 'UPDATE_DOG_FAILED';

export const DELETE_DOG = 'DELETE_DOG';
export const DELETE_DOG_FAILED = 'DELETE_DOG_FAILED';

export const SEND_REMINDER = 'SEND_REMINDER';
export const SEND_REMINDER_FAILED = 'SEND_REMINDER_FAILED'

export const CHECK_ZIPCODE_SUCCESSFULLY = 'CHECK_ZIPCODE_SUCCESSFULLY';
export const CHECK_ZIPCODE_FAILED = 'CHECK_ZIPCODE_FAILED';

export const FIELD_OFFICE_DETAIL_SUCCESSFULLY = 'FIELD_OFFICE_DETAIL_SUCCESSFULLY';
export const FIELD_OFFICE_DETAIL_FAILED = 'FIELD_OFFICE_DETAIL_FAILED';

export const GET_PRICING_SUCCESSFULLY = 'GET_PRICING_SUCCESSFULLY';
export const GET_PRICING_FAILED = 'GET_PRICING_FAILED';

export const ADD_SRVICE_ORDER_ENQUIRY = 'ADD_SRVICE_ORDER_ENQUIRY';
export const ADD_SRVICE_ORDER_ENQUIRY_FAILED = 'ADD_SRVICE_ORDER_ENQUIRY_FAILED';

export const UPDATE_SERVICE_ORDER_ENQUIRY = 'UPDATE_SERVICE_ORDER_ENQUIRY';
export const UPDATE_SERVICE_ORDER_ENQUIRY_FAILED = 'UPDATE_SERVICE_ORDER_ENQUIRY_FAILED';

export const GET_INVOICE_LIST = 'GET_INVOICE_LIST';
export const GET_INVOICE_LIST_FAILED = 'GET_INVOICE_LIST_FAILED';

export const GET_INVOICE_CREDIT_MEMO_LIST = 'GET_INVOICE_CREDIT_MEMO_LIST';
export const GET_INVOICE_CREDIT_MEMO_LIST_FAILED = 'GET_INVOICE_CREDIT_MEMO_LIST_FAILED';

export const GET_FINALIZE_INVOICE = 'GET_FINALIZE_INVOICE';
export const GET_FINALIZE_INVOICE_FAILED = 'GET_FINALIZE_INVOICE_FAILED';

export const GET_INVOICE_DETAIL = 'GET_INVOICE_DETAIL';
export const GET_INVOICE_DETAIL_FAILED = 'GET_INVOICE_DETAIL_FAILED';

export const GET_INVOICE_DESCRIPTION_SUCCESSFULLY = "GET_INVOICE_DESCRIPTION_SUCCESSFULLY";
export const GET_INVOICE_DESCRIPTION_FAILED = "GET_INVOICE_DESCRIPTION_FAILED";

export const SERVICE_ORDER_NUMBER_LIST = 'SERVICE_ORDER_NUMBER_LIST';
export const SERVICE_ORDER_NUMBER_LIST_FAILED = 'SERVICE_ORDER_NUMBER_LIST_FAILED';

export const GET_INVOICE_SUMMARY = 'GET_INVOICE_SUMMARY';
export const GET_INVOICE_SUMMARY_FAILED = 'GET_INVOICE_SUMMARY_FAILED';

export const SEND_INVOICE = 'SEND_INVOICE';
export const SEND_INVOICE_FAILED = 'SEND_INVOICE_FAILED';

export const PRINT_INVOICE = 'PRINT_INVOICE';
export const PRINT_INVOICE_FAILED = 'PRINT_INVOICE_FAILED';

export const ADD_INVOICE = 'ADD_INVOICE';
export const ADD_INVOICE_FAILED = 'ADD_INVOICE_FAILED';

export const ADD_MANUAL_INVOICE = 'ADD_MANUAL_INVOICE';
export const ADD_MANUAL_INVOICE_FAILED = 'ADD_MANUAL_INVOICE_FAILED';

export const EDIT_INVOICE = 'EDIT_INVOICE';
export const EDIT_INVOICE_FAILED = 'EDIT_INVOICE_FAILED';

export const DELETE_INVOICE = 'DELETE_INVOICE';
export const DELETE_INVOICE_FAILED = 'DELETE_INVOICE_FAILED';

export const ADD_INVOICE_LINE_ITEM = 'ADD_INVOICE_LINE_ITEM';
export const ADD_INVOICE_LINE_ITEM_FAILED = 'ADD_INVOICE_LINE_ITEM_FAILED';

export const EDIT_INVOICE_LINE_ITEM = 'EDIT_INVOICE_LINE_ITEM';
export const EDIT_INVOICE_LINE_ITEM_FAILED = 'EDIT_INVOICE_LINE_ITEM_FAILED';

export const DELETE_INVOICE_LINE_ITEM = 'DELETE_INVOICE_LINE_ITEM';
export const DELETE_INVOICE_LINE_ITEM_FAILED = 'DELETE_INVOICE_LINE_ITEM_FAILED';

export const GET_STAFF_LIST_SUCCESSFULLY = 'GET_STAFF_LIST_SUCCESSFULLY';
export const GET_STAFF_LIST_FAILED = 'GET_STAFF_LIST_FAILED';

export const ADD_NON_SERVICEABLE_ENQUIRY = 'ADD_NON_SERVICEABLE_ENQUIRY';
export const ADD_NON_SERVICEABLE_ENQUIRY_FAILED = 'ADD_NON_SERVICEABLE_ENQUIRY_FAILED';

export const DELETE_PHONE_NUMBER = 'DELETE_PHONE_NUMBER';
export const DELETE_PHONE_NUMBER_FAILED = 'DELETE_PHONE_NUMBER_FAILED';

export const ADD_STAX_PAYMENT_INFO = "ADD_STAX_PAYMENT_INFO";
export const ADD_STAX_PAYMENT_INFO_FAILED = "ADD_STAX_PAYMENT_INFO_FAILED";

//Case management
export const GET_MESSAGE_SUCCESSFULLY = 'GET_MESSAGE_SUCCESSFULLY';
export const GET_MESSAGE_FAILED = 'GET_MESSAGE_FAILED';
export const GET_REASON_LIST = 'GET_REASON_LIST';
export const GET_REASON_LIST_FAILED = 'GET_REASON_LIST_FAILED';

export const GET_ALL_CUSTOMER_LIST_SUCCESSFULLY = 'GET_ALL_CUSTOMER_LIST_SUCCESSFULLY';
export const GET_ALL_CUSTOMER_LIST_FAILED = 'GET_ALL_CUSTOMER_LIST_FAILED';

export const CREATE_MESSAGE_SUCCESSFULLY = 'CREATE_MESSAGE_SUCCESSFULLY';
export const CREATE_MESSAGE_FAILED = 'CREATE_MESSAGE_FAILED';

export const MESSAGE_REPLAY = 'MESSAGE_REPLAY';
export const MESSAGE_REPLAY_FAILED = 'MESSAGE_REPLAY_FAILED';

export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const UPDATE_MESSAGE_FAILED = 'UPDATE_MESSAGE_FAILED';

export const MESSAGE_COUNT = 'MESSAGE_COUNT';
export const MESSAGE_COUNT_FAILED = 'MESSAGE_COUNT_FAILED';

//Franchise Management
export const GET_FIELD_OFFICE_SUCCESSFULLY = 'GET_FIELD_OFFICE_SUCCESSFULLY';
export const GET_FIELD_OFFICE_FAILED = 'GET_FIELD_OFFICE_FAILED';

export const ADD_FIELD_OFFICE_SUCCESSFULLY = 'ADD_FIELD_OFFICE_SUCCESSFULLY';
export const ADD_FIELD_OFFICE_FAILED = 'ADD_FIELD_OFFICE_FAILED';

export const CLOSE_FIELD_OFFICE_SUCCESSFULLY = 'CLOSE_FIELD_OFFICE_SUCCESSFULLY';
export const CLOSE_FIELD_OFFICE_FAILED = 'CLOSE_FIELD_OFFICE_FAILED';

export const EDIT_FIELD_OFFICE_SUCCESSFULLY = 'EDIT_FIELD_OFFICE_SUCCESSFULLY';
export const EDIT_FIELD_OFFICE_FAILED = 'EDIT_FIELD_OFFICE_FAILED';

export const UPDATE_FIELD_OFFICE_SUCCESSFULLY = 'UPDATE_FIELD_OFFICE_SUCCESSFULLY';
export const UPDATE_FIELD_OFFICE_FAILED = 'UPDATE_FIELD_OFFICE_FAILED';

export const GET_ALL_INITIAL_CLEANING_DATA_SUCESSFULLY = 'GET_ALL_INITIAL_CLEANING_DATA_SUCESSFULLY';
export const GET_ALL_INITIAL_CLEANING_DATA_FAILED = 'GET_ALL_INITIAL_CLEANING_DATA_FAILED';

export const GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_SUCESSFULLY = 'GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_SUCESSFULLY';
export const GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_FAILED = 'GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_FAILED';

export const SAVE_AREA_SUCESSFULLY = 'SAVE_AREA_SUCESSFULLY';
export const SAVE_AREA_FAILED = 'SAVE_AREA_FAILED';

export const UPDATE_FILED_CLEAN_SUCESSFULLY = 'UPDATE_FILED_CLEAN_SUCESSFULLY';
export const UPDATE_FILED_CLEAN_FAILED = 'UPDATE_FILED_CLEAN_FAILED';

export const UPDATE_FIELD_ADDON_SUCCESSFULLY = 'UPDATE_FIELD_ADDON_SUCCESSFULLY';
export const UPDATE_FIELD_ADDON_FAILED = 'UPDATE_FIELD_ADDON_FAILED';

export const ADD_FIELD_ALERT_SUCCESSFULLY = 'ADD_FIELD_ALERT_SUCCESSFULLY';
export const ADD_FIELD_ALERT_FAILED = 'ADD_FIELD_ALERT_FAILED';

export const GET_FIELD_ALERT_SUCCESSFULLY = 'GET_FIELD_ALERT_SUCCESSFULLY';
export const GET_FIELD_ALERT_FAILED = 'GET_FIELD_ALERT_FAILED';

export const UPDATE_FIELD_ALERT_SUCCESSFULLY = 'UPDATE_FIELD_ALERT_SUCCESSFULLY';
export const UPDATE_FIELD_ALERT_FAILED = 'UPDATE_FIELD_ALERT_FAILED';

export const GET_STANDARD_CLEANING_SUCCESSFULLY = 'GET_STANDARD_CLEANING_SUCCESSFULLY';
export const GET_STANDARD_CLEANING_FAILED = 'GET_STANDARD_CLEANING_FAILED';

export const UPDATE_STANDARD_CLEANING_SUCCESSFULLY = 'UPDATE_STANDARD_CLEANING_SUCCESSFULLY';
export const UPDATE_STANDARD_CLEANING_FAILED = 'UPDATE_STANDARD_CLEANING_FAILED';

export const ADD_INITIAL_CLEANING_SUCCESSFULLY = 'ADD_INITIAL_CLEANING_SUCCESSFULLY';
export const ADD_INITIAL_CLEANING_FAILED = 'ADD_INITIAL_CLEANING_FAILED';

export const GET_INITIAL_CLEANING_SUCCESSFULLY = 'GET_INITIAL_CLEANING_SUCCESSFULLY';
export const GET_INITIAL_CLEANING_FAILED = 'GET_INITIAL_CLEANING_FAILED';

export const DELETE_INITIAL_CLEANING_SUCCESSFULLY = 'DELETE_INITIAL_CLEANING_SUCCESSFULLY';
export const DELETE_INITIAL_CLEANING_FAILED = 'DELETE_INITIAL_CLEANING_FAILED';

export const LOGIN_QUICKBOOK = 'LOGIN_QUICKBOOK';
export const LOGIN_QUICKBOOK_FAILED = 'LOGIN_QUICKBOOK_FAILED';

export const LOGIN_CALLBACK_QUICKBOOK = 'LOGIN_CALLBACK_QUICKBOOK';
export const LOGIN_CALLBACK_QUICKBOOK_FAILED = 'LOGIN_CALLBACK_QUICKBOOK_FAILED';

export const GET_COLLECTION_DETAIL = 'GET_COLLECTION_DETAIL';
export const GET_COLLECTION_DETAIL_FAILED = 'GET_COLLECTION_DETAIL_FAILED';

export const GET_ADDON_COLLECTION_DETAIL = 'GET_ADDON_COLLECTION_DETAIL';
export const GET_ADDON_COLLECTION_DETAIL_FAILED = 'GET_ADDON_COLLECTION_DETAIL_FAILED';

export const GET_DASHBOARD_STAT = 'GET_DASHBOARD_STAT';
export const GET_DASHBOARD_STAT_FAILED = 'GET_DASHBOARD_STAT_FAILED';

export const GET_CUSTOMER_MATRIX = 'GET_CUSTOMER_MATRIX';
export const GET_CUSTOMER_MATRIX_FAILED = 'GET_CUSTOMER_MATRIX_FAILED';

export const GET_CUSTOMER_MATRIX_V1 = 'GET_CUSTOMER_MATRIX_V1';
export const GET_CUSTOMER_MATRIX_V1_FAILED = 'GET_CUSTOMER_MATRIX_V1_FAILED';

export const GET_ZIP_CODES = 'GET_ZIP_CODES';
export const GET_ZIP_CODES_FAILED = 'GET_ZIP_CODES_FAILED';
export const GET_ZIP_CODES_SUCCESSFULLY = 'GET_ZIP_CODES_SUCCESSFULLY';

export const GET_STAX_KEYS_SUCCESSFULLY = 'GET_STAX_KEYS_SUCCESSFULLY';
export const GET_STAX_KEYS_FAILED = 'GET_STAX_KEYS_FAILED';

export const UPDATE_STAX_KEYS_SUCCESSFULLY = 'UPDATE_STAX_KEYS_SUCCESSFULLY';
export const UPDATE_STAX_KEYS_FAILED = 'UPDATE_STAX_KEYS_FAILED';

export const GET_PULSEM_KEYS_SUCCESSFULLY = 'GET_PULSEM_KEYS_SUCCESSFULLY';
export const GET_PULSEM_KEYS_FAILED = 'GET_PULSEM_KEYS_FAILED';

export const UPDATE_PULSEM_KEYS_SUCCESSFULLY = 'UPDATE_PULSEM_KEYS_SUCCESSFULLY';
export const UPDATE_PULSEM_KEYS_FAILED = 'UPDATE_PULSEM_KEYS_FAILED';

export const GET_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY = 'GET_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY';
export const GET_SERVICE_NOTIFICATION_KEYS_FAILED = 'GET_SERVICE_NOTIFICATION_KEYS_FAILED';

export const UPDATE_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY = 'UPDATE_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY';
export const UPDATE_SERVICE_NOTIFICATION_KEYS_FAILED = 'UPDATE_SERVICE_NOTIFICATION_KEYS_FAILED';

//Account Listing
export const GET_ACCOUNT_LISTING_SUCCESSFULLY = 'GET_ACCOUNT_LISTING_SUCCESSFULLY';
export const GET_ACCOUNT_LISTING_FAILED = 'GET_ACCOUNT_LISTING_FAILED';


export const GET_TAB_DATA_SUCCESSFULLY = 'GET_TAB_DATA_SUCCESSFULLY';
export const GET_TAB_DATA_FAILED = 'GET_TAB_DATA_FAILED';

export const ADD_LOG_PAYMENT_SUCCESSFULLY = 'ADD_LOG_PAYMENT_SUCCESSFULLY';
export const ADD_LOG_PAYMENT_FAILED = 'ADD_LOG_PAYMENT_FAILED';

export const ADD_MANUAL_LOG_PAYMENT_SUCCESSFULLY = 'ADD_MANUAL_LOG_PAYMENT_SUCCESSFULLY';
export const ADD_MANUAL_LOG_PAYMENT_FAILED = 'ADD_MANUAL_LOG_PAYMENT_FAILED';

export const DELETE_LOG_PAYMENT_SUCCESSFULLY = 'DELETE_LOG_PAYMENT_SUCCESSFULLY';
export const DELETE_LOG_PAYMENT_FAILED = 'DELETE_LOG_PAYMENT_FAILED';

export const GET_EXPIRED_CARD_SUCCESSFULLY = 'GET_EXPIRED_CARD_SUCCESSFULLY';
export const GET_EXPIRED_CARD_FAILED = 'GET_EXPIRED_CARD_FAILED';

export const REFUND_PAYMENT = 'REFUND_PAYMENT';
export const REFUND_PAYMENT_FAILED = 'REFUND_PAYMENT_FAILED';

export const GET_SALES_TAX = 'GET_SALES_TAX';
export const GET_SALES_TAX_FAILED = 'GET_SALES_TAX_FAILED';

export const GET_SALES_TAX_SUMMARY = 'GET_SALES_TAX_SUMMARY';
export const GET_SALES_TAX_SUMMARY_FAILED = 'GET_SALES_TAX_SUMMARY_FAILED';

export const SUSPEND_ACCOUNT = 'SUSPEND_ACCOUNT';
export const SUSPEND_ACCOUNT_FAILED = 'SUSPEND_ACCOUNT_FAILED';

export const GET_STAX_CUSTOMER_SUCCESSFULLY = 'GET_STAX_CUSTOMER_SUCCESSFULLY';
export const GET_STAX_CUSTOMER_FAILED = 'GET_STAX_CUSTOMER_FAILED';

export const GET_ALL_ACCOUNT_LIST_SUCCESSFULLY = 'GET_ALL_ACCOUNT_LIST_SUCCESSFULLY';
export const GET_ALL_ACCOUNT_LIST_FAILED = 'GET_ALL_ACCOUNT_LIST_FAILED';

// Commercial Management
export const CHECK_EMAIL = 'CHECK_EMAIL';
export const CHECK_EMAIL_FAILED = 'CHECK_EMAIL_FAILED';

export const GET_LIST_SUCCESSFULLY = 'GET_LIST_SUCCESSFULLY';
export const GET_LIST_FAILED = 'GET_LIST_FAILED';

export const ADD_QUOTE = 'ADD_QUOTE';
export const ADD_QUOTE_FAILED = 'ADD_QUOTE_FAILED';

export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const UPDATE_QUOTE_FAILED = 'UPDATE_QUOTE_FAILED';

export const GET_QUOTE_DETAIL = 'GET_QUOTE_DETAIL';
export const GET_QUOTE_DETAIL_FAILED = 'GET_QUOTE_DETAIL_FAILED';

export const GET_COMMERCIAL_PROPOSAL = 'GET_COMMERCIAL_PROPOSAL';
export const GET_COMMERCIAL_PROPOSAL_FAILED = 'GET_COMMERCIAL_PROPOSAL_FAILED';

export const GET_COMMERCIAL_PROPOSAL_DETAIL = 'GET_COMMERCIAL_PROPOSAL_DETAIL';
export const GET_COMMERCIAL_PROPOSAL_DETAIL_FAILED = 'GET_COMMERCIAL_PROPOSAL_DETAIL_FAILED';

export const GET_COMMERCIAL_CUSTOMER_LIST = 'GET_COMMERCIAL_CUSTOMER_LIST';
export const GET_COMMERCIAL_CUSTOMER_LIST_FAILED = 'GET_COMMERCIAL_CUSTOMER_LIST_FAILED';

export const GET_COMMERCIAL_CUSTOMER = 'GET_COMMERCIAL_CUSTOMER';
export const GET_COMMERCIAL_CUSTOMER_FAILED = 'GET_COMMERCIAL_CUSTOMER_FAILED';

export const UPDATE_COMMERCIAL_CUSTOMER = 'UPDATE_COMMERCIAL_CUSTOMER';
export const UPDATE_COMMERCIAL_CUSTOMER_FAILED = 'UPDATE_COMMERCIAL_CUSTOMER_FAILED';

export const DELETE_COMMERCIAL_CUSTOMER = 'DELETE_COMMERCIAL_CUSTOMER';
export const DELETE_COMMERCIAL_CUSTOMER_FAILED = 'DELETE_COMMERCIAL_CUSTOMER_FAILED';

export const ADD_GUEST_USER = 'ADD_GUEST_USER';
export const ADD_GUEST_USER_FAILED = 'ADD_GUEST_USER_FAILED';

export const UPDATE_GUEST_USER = 'UPDATE_GUEST_USER';
export const UPDATE_GUEST_USER_FAILED = 'UPDATE_GUEST_USER_FAILED';

export const PATCH_COMMERCIAL_PROPOSAL = 'PATCH_COMMERCIAL_PROPOSAL';
export const PATCH_COMMERCIAL_PROPOSAL_FAILED = 'PATCH_COMMERCIAL_PROPOSAL_FAILED';

export const DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM = 'DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM';
export const DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM_FAILED = 'DELETE_COMMERCIAL_PROPOSAL_LINE_ITEM_FAILED';

export const DELETE_INNER_PROPOSAL = 'DELETE_INNER_PROPOSAL';
export const DELETE_INNER_PROPOSAL_FAILED = 'DELETE_INNER_PROPOSAL_FAILED';

export const DELETE_GUEST_USER = 'DELETE_GUEST_USER';
export const DELETE_GUEST_USER_FAILED = 'DELETE_GUEST_USER_FAILED';

export const ADD_BLOCK_USER = 'ADD_BLOCK_USER';
export const ADD_BLOCK_USER_FAILED = 'ADD_BLOCK_USER_FAILED';

export const DELETE_BLOCK_USER = 'DELETE_BLOCK_USER';
export const DELETE_BLOCK_USER_FAILED = 'DELETE_BLOCK_USER_FAILED';

export const GET_RESOURCE_LIST = 'GET_RESOURCE_LIST';
export const GET_RESOURCE_LIST_FAILED = 'GET_RESOURCE_LIST_FAILED';

export const ADD_RESOURCE = 'ADD_RESOURCE';
export const ADD_RESOURCE_FAILED = 'ADD_RESOURCE_FAILED';

export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';
export const UPDATE_RESOURCE_FAILED = 'UPDATE_RESOURCE_FAILED';

export const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const DELETE_RESOURCE_FAILED = 'DELETE_RESOURCE_FAILED';

export const ADD_COMMERCIAL_PROPOSAL = 'ADD_COMMERCIAL_PROPOSAL';
export const ADD_COMMERCIAL_PROPOSAL_FAILED = 'ADD_COMMERCIAL_PROPOSAL_FAILED';

export const ADD_INNER_COMMERCIAL_PROPOSAL = 'ADD_INNER_COMMERCIAL_PROPOSAL';
export const ADD_INNER_COMMERCIAL_PROPOSAL_FAILED = 'ADD_INNER_COMMERCIAL_PROPOSAL_FAILED';

export const UPDATE_INNER_COMMERCIAL_PROPOSAL = 'ADD_INNER_COMMERCIAL_PROPOSAL';
export const UPDATE_INNER_COMMERCIAL_PROPOSAL_FAILED = 'ADD_INNER_COMMERCIAL_PROPOSAL_FAILED';

export const RESEND_INVOICE_SUCCESSFULLY = 'RESEND_INVOICE_SUCCESSFULLY';
export const RESEND_INVOICE_FAILED = 'RESEND_INVOICE_FAILED';

export const VOID_INVOICE_SUCCESSFULLY = 'VOID_INVOICE_SUCCESSFULLY';
export const VOID_INVOICE_FAILED = 'VOID_INVOICE_FAILED';

export const SALES_BY_ITEM_SUCCESSFULLY = 'SALES_BY_ITEM_SUCCESSFULLY';
export const SALES_BY_ITEM_FAILED = 'SALES_BY_ITEM_FAILED';

export const OVERVIEW_INVOICE_SUCCESSFULLY = 'OVERVIEW_INVOICE_SUCCESSFULLY';
export const OVERVIEW_INVOICE_FAILED = 'OVERVIEW_INVOICE_FAILED';


export const GET_AGGING_SUMMARY_SUCCESSFULLY = 'GET_AGGING_SUMMARY_SUCCESSFULLY';
export const GET_AGGING_SUMMARY_FAILED = 'GET_AGGING_SUMMARY_FAILED';

export const SUSPEND_AGGING_SUMMARY_SUCCESSFULLY = 'SUSPEND_AGGING_SUMMARY_SUCCESSFULLY';
export const SUSPEND_AGGING_SUMMARY_FAILED = 'SUSPEND_AGGING_SUMMARY_FAILED';


export const GET_MONTHLY_FORECAST_SUCCESSFULLY = 'GET_MONTHLY_FORECAST_SUCCESSFULLY';
export const GET_MONTHLY_FORECAST_FAILED = 'GET_MONTHLY_FORECAST_FAILED';

export const LOGIN_STRIPE_SUCCESSFULLY = 'LOGIN_STRIPE_SUCCESSFULLY';
export const LOGIN_STRIPE_FAILED = 'LOGIN_STRIPE_FAILED';

export const GET_KANBAN_LIST = 'GET_KANBAN_LIST';
export const GET_KANBAN_LIST_FAILED = 'GET_KANBAN_LIST_FAILED';

export const REQUEST_REPAIR = 'REQUEST_REPAIR';
export const REQUEST_REPAIR_FAILED = 'REQUEST_REPAIR_FAILED';

export const SERVICE_AGREEMENT_LIST = 'SERVICE_AGREEMENT_LIST';
export const SERVICE_AGREEMENT_LIST_FAILED = 'SERVICE_AGREEMENT_LIST_FAILED';

export const ADD_SERVICE_AGREEMENT = 'ADD_SERVICE_AGREEMENT';
export const ADD_SERVICE_AGREEMENT_FAILED = 'ADD_SERVICE_AGREEMENT_FAILED';

export const DELETE_SERVICE_AGREEMENT = 'DELETE_SERVICE_AGREEMENT';
export const DELETE_SERVICE_AGREEMENT_FAILED = 'DELETE_SERVICE_AGREEMENT_FAILED';

export const SEND_COMMERCIAL_PROPOSAL_MAIL = 'SEND_COMMERCIAL_PROPOSAL_MAIL';
export const SEND_COMMERCIAL_PROPOSAL_MAIL_FAILED = 'SEND_COMMERCIAL_PROPOSAL_MAIL_FAILED';

export const UPDATE_SERVICE_LINE_ITEM = 'UPDATE_SERVICE_LINE_ITEM';
export const UPDATE_SERVICE_LINE_ITEM_FAILED = 'UPDATE_SERVICE_LINE_ITEM_FAILED';

export const GET_BDA = 'GET_BDA';
export const GET_BDA_FAILED = 'GET_BDA_FAILED';

export const GET_MONTHLY_FORECAST_TOTAL_SUCCESSFULLY = 'GET_MONTHLY_FORECAST_TOTAL_SUCCESSFULLY';
export const GET_MONTHLY_FORECAST_TOTAL_FAILED = 'GET_MONTHLY_FORECAST_TOTAL_FAILED';

//Field Tech
export const GET_SCHEDULING_ERRORS_LIST = 'GET_SCHEDULING_ERRORS_LIST';
export const GET_SCHEDULING_ERRORS_LIST_FAILED = 'GET_SCHEDULING_ERRORS_LIST_FAILED';


export const GET_FIELD_STAFFF_LIST = 'GET_FIELD_STAFFF_LIST';
export const GET_FIELD_STAFFF_LIST_FAILED = 'GET_FIELD_STAFFF_LIST_FAILED';

export const UPDATE_FIELD_STAFFF = 'UPDATE_FIELD_STAFFF';
export const UPDATE_FIELD_STAFFF_FAILED = 'UPDATE_FIELD_STAFFF_FAILED';

export const GET_SERVICE_ALLOCATION_INTIAL_LIST = 'GET_SERVICE_ALLOCATION_INTIAL_LIST';
export const GET_SERVICE_ALLOCATION_INTIAL_FAILED = 'GET_SERVICE_ALLOCATION_INTIAL_FAILED';


export const GET_SERVICE_ALLOCATION_RESIDENTAIL_LIST = 'GET_SERVICE_ALLOCATION_RESIDENTAIL_LIST';
export const GET_SERVICE_ALLOCATION_RESIDENTAIL_FAILED = 'GET_SERVICE_ALLOCATION_RESIDENTAIL_FAILED';

export const GET_SERVICE_ALLOCATION_COMMERCIAL_LIST = 'GET_SERVICE_ALLOCATION_COMMERCIAL_LIST';
export const GET_SERVICE_ALLOCATION_COMMERCIAL_FAILED = 'GET_SERVICE_ALLOCATION_COMMERCIAL_FAILED';

export const GET_SERVICE_ALLOCATION_INSTALL_LIST = 'GET_SERVICE_ALLOCATION_INSTALL_LIST';
export const GET_SERVICE_ALLOCATION_INSTALL_FAILED = 'GET_SERVICE_ALLOCATION_INSTALL_FAILED';

export const GET_SERVICE_WEEKLY_ALLOCATION = 'GET_SERVICE_WEEKLY_ALLOCATION';
export const GET_SERVICE_WEEKLY_ALLOCATION_FAILED = 'GET_SERVICE_WEEKLY_ALLOCATION_FAILED';
export const RESET_SERVICE_WEEKLY_ALLOCATION = 'RESET_SERVICE_WEEKLY_ALLOCATION';


export const CANCEL_SERVICE_WEEKLY_ALLOCATION = 'CANCEL_SERVICE_WEEKLY_ALLOCATION';
export const CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED = 'CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED';

export const ADD_BLOCKDAY_SUCCESSFULLY = 'ADD_BLOCKDAY_SUCCESSFULLY';
export const ADD_BLOCKDAY_FAILED = 'ADD_BLOCKDAY_FAILED';


export const GET_BLOCKDAY_SUCCESSFULLY = 'GET_BLOCKDAY_SUCCESSFULLY';
export const GET_BLOCKDAY_FAILED = 'GET_BLOCKDAY_FAILED';

export const GET_FIELD_SERVICES_SUCCESSFULLY = 'GET_FIELD_SERVICES_SUCCESSFULLY';
export const GET_FIELD_SERVICES_FAILED = 'GET_FIELD_SERVICES_FAILED';

export const SAVE_FIELD_SERVICE_SUCCESSFULLY = 'SAVE_FIELD_SERVICE_SUCCESSFULLY';
export const SAVE_FIELD_SERVICE_FAILED = 'SAVE_FIELD_SERVICE_FAILED ';

export const GET_WEEKLY_AVG_SUCCESSFULLY = 'GET_WEEKLY_AVG_SUCCESSFULLY';
export const GET_WEEKLY_AVG_FAILED = 'GET_WEEKLY_AVG_FAILED';


export const ADD_PWS_INSTALL = 'ADD_PWS_INSTALL';
export const ADD_PWS_INSTALL_FAILED = 'ADD_PWS_INSTALL_FAILED';

export const UPDATE_PWS_INSTALL = 'UPDATE_PWS_INSTALL';
export const UPDATE_PWS_INSTALL_FAILED = 'UPDATE_PWS_INSTALL_FAILED';

export const GET_PROPOSAL_PDF = 'GET_PROPOSAL_PDF';
export const GET_PROPOSAL_PDF_FAILED = 'GET_PROPOSAL_PDF_FAILED';

export const GET_INVOICE_VIEW_SUCCESSFULLY = 'GET_INVOICE_VIEW_SUCCESSFULLY';
export const GET_INVOICE_VIEW_FAILED = 'GET_INVOICE_VIEW_FAILED';

export const UPDATE_INVOICE_VIEW_SUCCESSFULLY = 'UPDATE_INVOICE_VIEW_SUCCESSFULLY';
export const UPDATE_INVOICE_VIEW_FAILED = 'UPDATE_INVOICE_VIEW_FAILED';

export const DELETE_INVOICE_ITEMS_SUCCESSFULLY = 'DELETE_INVOICE_ITEMS_SUCCESSFULLY';
export const DELETE_INVOICE_ITEMS_FAILED = 'DELETE_INVOICE_ITEMS_FAILED';

export const FINALIZE_INVOICE_SUCCESSFULLY = 'FINALIZE_INVOICE_SUCCESSFULLY';
export const FINALIZE_INVOICE_FAILED = 'FINALIZE_INVOICE_FAILED';


export const PRINT_INVOICE_SUCCESSFULLY = 'PRINT_INVOICE_SUCCESSFULLY';
// export const PRINT_INVOICE_FAILED = 'PRINT_INVOICE_FAILED';

export const SEND_INVOICE_REMINDERS_SUCCESSFULLY = 'SEND_INVOICE_REMINDERS_SUCCESSFULLY';
export const SEND_INVOICE_REMINDERS_FAILED = 'SEND_INVOICE_REMINDERS_FAILED';

export const BATCH_INVOICE_SUCCESSFULLY = 'BATCH_INVOICE_SUCCESSFULLY';
export const BATCH_INVOICE_FAILED = 'BATCH_INVOICE_FAILED';

export const GET_SINGLE_SERVICE_ORDER_SUCCESSFULLY = 'GET_SINGLE_SERVICE_ORDER_SUCCESSFULLY';
export const GET_SINGLE_SERVICE_ORDER_FAILED = 'GET_SINGLE_SERVICE_ORDER_FAILED';

export const GET_SERVICE_STATISTICS_SUCCESSFULLY = 'GET_SERVICE_STATISTICS_SUCCESSFULLY';
export const GET_SERVICE_STATISTICS_FAILED = 'GET_SERVICE_STATISTICS_FAILED';

export const RETURN_OPTIMIZATION_SUCCESSFULLY = 'RETURN_OPTIMIZATION_SUCCESSFULLY';
export const RETURN_OPTIMIZATION_FAILED = 'RETURN_OPTIMIZATION_FAILED';

export const UPDATE_FIELD_SERVICE_SUCCESSFULLY = 'UPDATE_FIELD_SERVICE_SUCCESSFULLY';
export const UPDATE_FIELD_SERVICE_FAILED = 'UPDATE_FIELD_SERVICE_FAILED';

export const GET_FIELD_STAFFF_LIST_BY_ID_SUCCESSFULLY = 'GET_FIELD_STAFFF_LIST_BY_ID_SUCCESSFULLY';
export const GET_FIELD_STAFFF_LIST_BY_ID_FAILED = 'GET_FIELD_STAFFF_LIST_BY_ID_FAILED';

export const CHECK_MAIL_SUCCESSFULLY = 'CHECK_MAIL_SUCCESSFULLY';
export const CHECK_MAIL_FAILED = 'CHECK_MAIL_FAILED'

export const GET_EXPORT_INVOICE_SAATEMENT_SUCCESSFULLY = 'GET_EXPORT_INVOICE_SAATEMENT_SUCCESSFULLY';
export const GET_EXPORT_INVOICE_SAATEMENT_FAILED = 'GET_EXPORT_INVOICE_SAATEMENT_FAILED';

export const GET_PAYMENT_HISTORY_SUCCESSFULLY = 'GET_PAYMENT_HISTORY_SUCCESSFULLY';
export const GET_PAYMENT_HISTORY_FAILED = 'GET_PAYMENT_HISTORY_FAILED';

export const POST_PAYMENT_HISTORY_SUCCESSFULLY = 'POST_PAYMENT_HISTORY_SUCCESSFULLY';
export const POST_PAYMENT_HISTORY_FAILED = 'POST_PAYMENT_HISTORY_FAILED';

export const DELETE_PAYMENT_HISTORY_SUCCESSFULLY = 'DELETE_PAYMENT_HISTORY_SUCCESSFULLY';
export const DELETE_PAYMENT_HISTORY_FAILED = 'DELETE_PAYMENT_HISTORY_FAILED';

export const GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY = 'GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY';
export const GET_PAYMENT_HISTORY_NEW_FAILED = 'GET_PAYMENT_HISTORY_NEW_FAILED';

export const GET_OPTIMOROUTE_KEY_SUCCESSFULLY = 'GET_OPTIMOROUTE_KEY_SUCCESSFULLY';
export const GET_OPTIMOROUTE_KEY_FAILED = 'GET_OPTIMOROUTE_KEY_FAILED';

export const UPDATE_OPTIMOROUTE_KEY_SUCCESSFULLY = 'UPDATE_OPTIMOROUTE_KEY_SUCCESSFULLY';
export const UPDATE_OPTIMOROUTE_KEY_FAILED = 'UPDATE_OPTIMOROUTE_KEY_FAILED';

export const GET_SERVICE_EOD_REPORT_SUCCESSFULLY = 'GET_SERVICE_EOD_REPORT_SUCCESSFULLY';
export const GET_SERVICE_EOD_REPORT_FAILED = 'GET_SERVICE_EOD_REPORT_FAILED';


export const RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY = 'RESCHEDULE_MULTIPLE_SERVICES_SUCCESSFULLY';
export const RESCHEDULE_MULTIPLE_SERVICES_FAILED = 'RESCHEDULE_MULTIPLE_SERVICES_FAILED';

export const GET_SERVICE_ROUTE_CSV_DOWNLOAD_SUCCESSFULLY = 'GET_SERVICE_ROUTE_CSV_DOWNLOAD_SUCCESSFULLY';
export const GET_SERVICE_ROUTE_CSV_DOWNLOAD_FAILED = 'GET_SERVICE_ROUTE_CSV_DOWNLOAD_FAILED';

export const GET_SERVICE_ROUTE_PDF_DOWNLOAD_SUCCESSFULLY = 'GET_SERVICE_ROUTE_PDF_DOWNLOAD_SUCCESSFULLY';
export const GET_SERVICE_ROUTE_PDF_DOWNLOAD_FAILED = 'GET_SERVICE_ROUTE_PDF_DOWNLOAD_FAILED';

export const GET_SERVICE_LIST_SUCCESSFULLY = 'GET_SERVICE_LIST_SUCCESSFULLY';
export const GET_SERVICE_LIST_FAILED = 'GET_SERVICE_LIST_FAILED';

export const GET_CUSTOMER_SERVICE_LIST_SUCCESSFULLY = 'GET_CUSTOMER_SERVICE_LIST_SUCCESSFULLY';
export const GET_CUSTOMER_SERVICE_LIST_FAILED = 'GET_CUSTOMER_SERVICE_LIST_FAILED'

export const CREATE_NEW_SERVICE_SUCCESSFULLY = 'CREATE_NEW_SERVICE_SUCCESSFULLY';
export const CREATE_NEW_SERVICE_FAILED = 'CREATE_NEW_SERVICE_FAILED';

export const LOCK_SERVICE_SUCCESSFULLY = 'LOCK_SERVICE_SUCCESSFULLY';
export const LOCK_SERVICE_FAILED = 'LOCK_SERVICE_FAILED';

//Reports
export const GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY = 'GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY';
export const GET_DAILY_LOG_FRANCHISE_FAILED = 'GET_DAILY_LOG_FRANCHISE_FAILED';

export const GET_DAILY_LOG_REPORTS_SUCCESSFULLY = 'GET_DAILY_LOG_REPORTS_SUCCESSFULLY';
export const GET_DAILY_LOG_REPORTS_FAILED = 'GET_DAILY_LOG_REPORTS_FAILED';

export const GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_SUCCESSFULLY = 'GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_SUCCESSFULLY';
export const GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_FAILED = 'GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_FAILED';

export const GET_CUSTOMER_STATEMENT_REPORT_SUCCESSFULLY = 'GET_CUSTOMER_STATEMENT_REPORT_SUCCESSFULLY';
export const GET_CUSTOMER_STATEMENT_REPORT_FAILED = 'GET_CUSTOMER_STATEMENT_REPORT_FAILED';

export const GET_REPORT_PDF_SUCCESSFULLY = 'GET_REPORT_PDF_SUCCESSFULLY';
export const GET_REPORT_PDF_FAILED = 'GET_REPORT_PDF_FAILED';

export const GET_REVENUE_REPORT_SUCCESSFULLY = 'GET_REVENUE_REPORT_SUCCESSFULLY';
export const GET_REVENUE_REPORT_FAILED = 'GET_REVENUE_REPORT_FAILED';

export const GET_REVENUE_REPORT_BY_ID_SUCCESSFULLY = 'GET_REVENUE_REPORT_BY_ID_SUCCESSFULLY';
export const GET_REVENUE_REPORT_BY_ID_FAILED = 'GET_REVENUE_REPORT_BY_ID_FAILED';

export const GET_REVENUE_REPORT_FRANCHISE_SUCCESSFULLY = 'GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY';
export const GET_REVENUE_REPORT_FRANCHISE_FAILED = 'GET_DAILY_LOG_FRANCHISE_FAILED';

export const GET_REPORT_ZIPCODE_LIST_SUCCESSFULLY = 'GET_REPORT_ZIPCODE_LIST_SUCCESSFULLY';
export const GET_REPORT_ZIPCODE_LIST_FAILED = 'GET_REPORT_ZIPCODE_LIST_FAILED';

export const GET_REPORT_TYPE_LIST_SUCCESSFULLY = 'GET_REPORT_TYPE_LIST_SUCCESSFULLY';
export const GET_REPORT_TYPE_LIST_FAILED = 'GET_REPORT_TYPE_LIST_FAILED'

export const GET_CUSTOMER_COMPLAINTS_FRANCHISE_SUCCESSFULLY = 'GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY';
export const GET_CUSTOMER_COMPLAINTS_FRANCHISE_FAILED = 'GET_DAILY_LOG_FRANCHISE_FAILED';

export const GET_CUSTOMER_COMPLAINTS_REPORT_SUCCESSFULLY = 'GET_CUSTOMER_COMPLAINTS_REPORT_SUCCESSFULLY';
export const GET_CUSTOMER_COMPLAINTS_REPORT_FAILED = 'GET_CUSTOMER_COMPLAINTS_REPORT_FAILED';

export const GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_SUCCESSFULLY = 'GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_SUCCESSFULLY';
export const GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_FAILED = 'GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_FAILED';

export const GET_COMMERCIAL_SALES_REPORTS_SUCCESSFULLY = 'GET_COMMERCIAL_SALES_REPORTS_SUCCESSFULLY';
export const GET_COMMERCIAL_SALES_REPORTS_FAILED = 'GET_COMMERCIAL_SALES_REPORTS_FAILED';

export const GET_COMMERCIAL_SALES_REPORTS_BY_ID_SUCCESSFULLY = 'GET_COMMERCIAL_SALES_REPORTS_BY_ID_SUCCESSFULLY';
export const GET_COMMERCIAL_SALES_REPORTS_BY_ID_FAILED = 'GET_COMMERCIAL_SALES_REPORTS_BY_ID_FAILED';

export const GET_COMMERCIAL_SALES_FRANCHISE_SUCCESSFULLY = 'GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY';
export const GET_COMMERCIAL_SALES_FRANCHISE_FAILED = 'GET_DAILY_LOG_FRANCHISE_FAILED';

export const GET_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY';
export const GET_CUSTOMER_PRICE_INCREASE_REPORT_FAILED = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FAILED';

export const POST_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY = 'POST_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY';
export const POST_CUSTOMER_PRICE_INCREASE_REPORT_FAILED = 'POST_CUSTOMER_PRICE_INCREASE_REPORT_FAILED';

export const GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_SUCCESSFULLY = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_SUCCESSFULLY';
export const GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_FAILED = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_FAILED';

export const GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_SUCCESSFULLY = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_SUCCESSFULLY';
export const GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_FAILED = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_FAILED';

export const GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_SUCCESSFULLY = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_SUCCESSFULLY';
export const GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_FAILED = 'GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_FAILED';

export const GET_SERVICE_REASONS_SUCCESSFULLY = 'GET_SERVICE_REASONS_SUCCESSFULLY';
export const GET_SERVICE_REASONS_FAILED = 'GET_SERVICE_REASONS_FAILED';

export const GET_CHANNELS_SUCCESSFULLY = 'GET_CHANNELS_SUCCESSFULLY';
export const GET_CHANNELS_FAILED = 'GET_CHANNELS_FAILED';

// Dashboard
export const GET_MESSAGE_ASSIGNED_TO_ME = 'GET_MESSAGE_ASSIGNED_TO_ME';
export const GET_MESSAGE_ASSIGNED_TO_ME_FAILED = 'GET_MESSAGE_ASSIGNED_TO_ME_FAILED';

export const GET_SERVICE_TYPE_COLLECTION = 'GET_SERVICE_TYPE_COLLECTION';
export const GET_SERVICE_TYPE_COLLECTION_FAILED = 'GET_SERVICE_TYPE_COLLECTION_FAILED';

export const GET_AUDIT_TRAIL = 'GET_AUDIT_TRAIL';
export const GET_AUDIT_TRAIL_FAILED = 'GET_AUDIT_TRAIL_FAILED';

export const GET_SCHEDULE_SERVICE = 'GET_SCHEDULE_SERVICE';
export const GET_SCHEDULE_SERVICE_FAILED = 'GET_SCHEDULE_SERVICE_FAILED';

//accounting
export const GET_QUICKBOOKS_SYNC_SUCCESSFULLY = 'GET_QUICKBOOKS_SYNC_SUCCESSFULLY';  
export const GET_QUICKBOOKS_SYNC_FAILED = 'GET_QUICKBOOKS_SYNC_FAILED';

// Last 3 Payment Done
export const GET_LAST_THREE_PAYMENTS_SUCCESSFULLY = 'GET_LAST_THREE_PAYMENTS_SUCCESSFULLY';  
export const GET_LAST_THREE_PAYMENTS_FAILED = 'GET_LAST_THREE_PAYMENTS_FAILED';  


// Google API
export const GET_GEOCODE = 'GET_GEOCODE';
export const GET_GEOCODE_FAILED = 'GET_GEOCODE_FAILED';

/**
 * AUTHOR: Ritesh Solanki
 * Change Date : 09/28/2021 (Tuesday)
 * New Redesign Changes
 */

// Get Service Order
export const GET_SERVICE_ORDER_FILTER = 'GET_SERVICE_ORDER_FILTER';
export const GET_SERVICE_ORDER_FILTER_FAILED = 'GET_SERVICE_ORDER_FILTER_FAILED';

// Get Work Order
export const GET_WORK_ORDER_FILTER = 'GET_WORK_ORDER_FILTER';
export const GET_WORK_ORDER_FILTER_FAILED = 'GET_WORK_ORDER_FILTER_FAILED';
export const GET_WORK_ORDER_LIST = 'GET_WORK_ORDER_LIST';
export const GET_WORK_ORDER_LIST_FAILED = 'GET_WORK_ORDER_LIST_FAILED';
export const GET_WORK_ORDER_DETAIL = 'GET_WORK_ORDER_DETAIL';
export const GET_WORK_ORDER_DETAIL_FAILED = 'GET_WORK_ORDER_DETAIL_FAILED';
export const GET_COM_WORK_ORDER_LIST = 'GET_COM_WORK_ORDER_LIST';
export const GET_COM_WORK_ORDER = 'GET_COM_WORK_ORDER';
export const GET_COM_WORK_ORDER_LIST_FAILED = 'GET_COM_WORK_ORDER_LIST_FAILED';
export const GET_COM_WORK_ORDER_FAILED = 'GET_COM_WORK_ORDER_FAILED';

// Get Field Technician
export const GET_FIELD_TECHNICIAN_FILTER = 'GET_FIELD_TECHNICIAN_FILTER';
export const GET_FIELD_TECHNICIAN_FILTER_FAILED = 'GET_FIELD_TECHNICIAN_FILTER_FAILED';

export const DEACTIVATE_SERVICE_ORDER = 'DEACTIVATE_SERVICE_ORDER';
export const DEACTIVATE_SERVICE_ORDER_FAILED = 'DEACTIVATE_SERVICE_ORDER_FAILED';

export const GET_REPRESENTATIVES_LIST = 'GET_REPRESENTATIVES_LIST';
export const GET_REPRESENTATIVES_LIST_FAILED = 'GET_REPRESENTATIVES_LIST_FAILED';

//GET_INVOICE_RECONCILIATION_REPORT
export const GET_INVOICE_RECONCILIATION_REPORT_SUCCESSFULLY = 'GET_INVOICE_RECONCILIATION_REPORT_SUCCESSFULLY';
export const GET_INVOICE_RECONCILIATION_REPORT_FAILED = 'GET_INVOICE_RECONCILIATION_REPORT_FAILED';

export const VALIDATE_COUPON_SUCCESSFULLY = 'VALIDATE_COUPON_SUCCESSFULLY';
export const VALIDATE_COUPON_FAILED = 'VALIDATE_COUPON_FAILED';

export const UPDATE_CALL_LOG = 'UPDATE_CALL_LOG';
export const UPDATE_CALL_LOG_FAILED = 'UPDATE_CALL_LOG_FAILED';

// Payment
export const GET_PAYMENT_SUCCESSFULLY = 'GET_PAYMENT_SUCCESSFULLY';
export const GET_PAYMENT_FAILED = 'GET_PAYMENT_FAILED';
export const CLEAN_PAYMENT_RESPONSE = 'CLEAN_PAYMENT_RESPONSE';

//Credit MEMO
export const ADD_CREDIT_MEMO_FAILED = 'ADD_CREDIT_MEMO_FAILED';
export const ADD_CREDIT_MEMO = 'ADD_CREDIT_MEMO';

export const GET_CREDIT_MEMO_DETAIL = 'GET_CREDIT_MEMO_DETAIL';
export const GET_CREDIT_MEMO_DETAIL_FAILED = 'GET_CREDIT_MEMO_DETAIL_FAILED';

export const ADD_CREDIT_MEMO_LINE_ITEM_FAILED = 'ADD_CREDIT_MEMO_LINE_ITEM_FAILED';
export const ADD_CREDIT_MEMO_LINE_ITEM = 'ADD_CREDIT_MEMO_LINE_ITEM';

export const LAST_THREE_CREDIT_MEMO = 'LAST_THREE_CREDIT_MEMO';
export const LAST_THREE_CREDIT_MEMO_FAILED = 'LAST_THREE_CREDIT_MEMO_FAILED';

export const GET_WORK_ORDER_TYPE_DESCRIPTION_SUCCESSFULLY = 'GET_WORK_ORDER_TYPE_DESCRIPTION_SUCCESSFULLY';
export const GET_WORK_ORDER_TYPE_DESCRIPTION_FAILED = 'GET_WORK_ORDER_TYPE_DESCRIPTION_FAILED';

// Work Order Report
export const GET_WORK_ORDERS_SUMMARY_SUCCESSFULLY = 'GET_WORK_ORDERS_SUMMARY_SUCCESSFULLY';
export const GET_WORK_ORDERS_SUMMARY_FAILED = 'GET_WORK_ORDERS_SUMMARY_FAILED';
export const GET_WORK_ORDERS_SUCCESSFULLY = 'GET_WORK_ORDERS_SUCCESSFULLY';
export const GET_WORK_ORDERS_FAILED = 'GET_WORK_ORDERS_FAILED';
export const POST_WORK_ORDERS_SUCCESSFULLY = 'POST_WORK_ORDERS_SUCCESSFULLY';
export const POST_WORK_ORDERS_FAILED = 'POST_WORK_ORDERS_FAILED';
export const POST_WORK_ORDERS_GENERATE_INVOICE_SUCCESSFULLY = 'POST_WORK_ORDERS_GENERATE_INVOICE_SUCCESSFULLY';
export const POST_WORK_ORDERS_GENERATE_INVOICE_FAILED = 'POST_WORK_ORDERS_GENERATE_INVOICE_FAILED';

//GET_CANCELLATION_REPORT
export const GET_CANCELLATION_REPORT_SUCCESSFULLY = 'GET_CANCELLATION_REPORT_SUCCESSFULLY';
export const GET_CANCELLATION_REPORT_FAILED = 'GET_CANCELLATION_REPORT_FAILED';

//GET_CANCELLATION_SUMMARY_REPORT
export const GET_CANCELLATION_SUMMARY_REPORT_SUCCESSFULLY = 'GET_CANCELLATION_SUMMARY_REPORT_SUCCESSFULLY';
export const GET_CANCELLATION_SUMMARY_REPORT_FAILED = 'GET_CANCELLATION_SUMMARY_REPORT_FAILED';

//GET_CANCELLATION_SUMMARY_REPORT
export const GET_BILLING_ADDRESS_SUCCESSFULLY = 'GET_BILLING_ADDRESS_SUCCESSFULLY';
export const GET_BILLING_ADDRESS_FAILED = 'GET_BILLING_ADDRESS_FAILED';

// ADD_UNATTACHED_PAYMENT_FAILED
export const ADD_UNATTACHED_PAYMENT_FAILED = 'ADD_UNATTACHED_PAYMENT_FAILED';
export const ADD_UNATTACHED_PAYMENT_SUCCESSFULLY = 'ADD_UNATTACHED_PAYMENT_SUCCESSFULLY';

// Refund
export const REFUND_REMAINING_BALANCE_SUCCESS = 'REFUND_REMAINING_BALANCE_SUCCESS';
export const REFUND_REMAINING_BALANCE_FAILED ='REFUND_REMAINING_BALANCE_FAILED';

// View By Work Order
export const GET_VIEW_BY_WORK_ORDER_LIST = 'GET_VIEW_BY_WORK_ORDER_LIST';
export const GET_VIEW_BY_WORK_ORDER_LIST_FAILED ='GET_VIEW_BY_WORK_ORDER_LIST_FAILED';

// Royalty Report
export const GET_ROYALTY_REPORT_FAILED = 'GET_ROYALTY_REPORT_FAILED';
export const GET_ROYALTY_REPORT_SUCCESSFULLY = 'GET_ROYALTY_REPORT_SUCCESSFULLY';
export const GET_ROYALTY_REPORT_CSV_FAILED = 'GET_ROYALTY_REPORT_CSV_FAILED';
export const GET_ROYALTY_REPORT_CSV_SUCCESSFULLY = 'GET_ROYALTY_REPORT_CSV_SUCCESSFULLY';
export const GET_ROYALTY_BREAKDOWN_SUCCESSFULLY = 'GET_ROYALTY_BREAKDOWN_SUCCESSFULLY';
export const GET_ROYALTY_BREAKDOWN_FAILED = 'GET_ROYALTY_BREAKDOWN_FAILED';

//Invoice Process
export const INVOICE_PROCESS_SUCCESSFULLY = 'INVOICE_PROCESS_SUCCESSFULLY';
export const INVOICE_PROCESS_FAILED ='INVOICE_PROCESS_FAILED';

//Invoice Email Send
export const INVOICE_EMAIL_SEND_SUCCESSFULLY = 'INVOICE_EMAIL_SEND_SUCCESSFULLY';
export const INVOICE_EMAIL_SEND_FAILED ='INVOICE_EMAIL_SEND_FAILED';

// Commercial Prepayment
export const GET_SERVICE_ORDERS_SUCCESSFULLY = 'GET_SERVICE_ORDERS_SUCCESSFULLY';
export const GET_SERVICE_ORDERS_FAILED = 'GET_SERVICE_ORDERS_FAILED';
export const GET_DISCOUNTS_CATALOG_SUCCESSFULY = 'GET_DISCOUNTS_CATALOG_SUCCESSFULY';
export const GET_DISCOUNTS_CATALOG_FAILED = 'GET_DISCOUNTS_CATALOG_FAILED';
export const CALCULATE_PREPAY_PRICE_SUCCESSFULY = 'CALCULATE_PREPAY_PRICE_SUCCESSFULY';
export const CALCULATE_PREPAY_PRICE_FAILED = 'CALCULATE_PREPAY_PRICE_FAILED';
export const PREPAY_CREATED_SUCCESSFULY = 'PREPAY_CREATED_SUCCESSFULY';
export const PREPAY_CREATED_FAILED = 'PREPAY_CREATED_FAILED';
export const CLEAN_PREPAYMENT_RESPONSE = 'CLEAN_PREPAYMENT_RESPONSE';

//Lead/Signup report
export const GET_RESIDENTIAL_LEAD_REPORT_SUCCESSFULLY = 'GET_RESIDENTIAL_LEAD_REPORT_SUCCESSFULLY';
export const GET_RESIDENTIAL_LEAD_REPORT_FAILED = 'GET_RESIDENTIAL_LEAD_REPORT_FAILED';
export const GET_RESIDENTIAL_SIGNUP_REPORT_SUCCESSFULLY = 'GET_RESIDENTIAL_SIGNUP_REPORT_SUCCESSFULLY';
export const GET_RESIDENTIAL_SIGNUP_REPORT_FAILED = 'GET_RESIDENTIAL_SIGNUP_REPORT_FAILED';
export const GET_RESIDENTIAL_LEAD_REPORT_CSV_FAILED = 'GET_RESIDENTIAL_LEAD_REPORT_CSV_FAILED';
export const GET_RESIDENTIAL_SIGNUP_REPORT_CSV_FAILED = 'GET_RESIDENTIAL_SIGNUP_REPORT_CSV_FAILED';
export const GET_COMMERCIAL_PROPOSAL_REPORT_CSV_FAILED = 'GET_COMMERCIAL_PROPOSAL_REPORT_CSV_FAILED';
export const GET_COMMERCIAL_SIGNUP_REPORT_CSV_FAILED = 'GET_COMMERCIAL_SIGNUP_REPORT_CSV_FAILED';
export const LOADED_EXPORT_REPORT = 'LOADED_EXPORT_REPORT';

//	Coupon Code Report
export const GET_COUPON_CODE_REPORT_SUCCESSFULLY = 'GET_COUPON_CODE_REPORT_SUCCESSFULLY';
export const GET_COUPON_CODE_REPORT_FAILED = 'GET_COUPON_CODE_REPORT_FAILED';